import { user } from './user';
import { getOAuthClient, isAuthenticated, refreshTokens } from '.';

/**
 * Returns the signed-in user's ID token, refreshing the stored tokens first
 * when they have expired. Throws when no token can be produced.
 */
export async function getFreshIdToken(): Promise<string> {
  if (!isAuthenticated()) {
    const userClient = getOAuthClient();
    const currentUser = await userClient.getUser();
    if (!currentUser) throw new Error('User not available');
    const refreshed = await refreshTokens(userClient, currentUser);
    if (!refreshed) throw new Error('Unable to refresh tokens');
  }

  const idToken = user?.getIdToken();
  if (!idToken) throw new Error('Id Token not available');
  return idToken;
}
